import gsap from "gsap"
import { useEffect, useRef, useState, useLayoutEffect } from "react"


const texts = [
  "Follow stairs to see my professional path",

  "I graduated in graphic design specializing in web and UX/UI design, in 2018 in France",

  "in 2019 I take my first steps in the working world as Freelance, this is where I cut my teeth as a UI/UX designer. At the same time, I discovered code and started learning it purely out of curiosity.",

  "Day after day, as I kept learning, I gradually evolved through projects as a Front-End Developer while still working as a UI/UX designer to create complete websites.",

  "I chose to dive deeper into development because I didn’t yet have the technical skills needed to fully bring my UI and UX ideas to life.",

  "I’ve always been drawn to immersive and visually bold 3D experiences on the web.",

  "When I felt confident enough to dive deeper, I naturally turned to creative technologies like Three.js and shaders, building on my long-time curiosity for Blender and 3D experimentation.",

  "I am currently looking for opportunities to learn, grow, and improve my skills within a team as a front-end developer, creative developer, or UX/UI designer.",

  "",

  "",

  "",

  "",

  "",

  "",
]
export default function TextByPoint({ activeInterestPointId }) {
  const showText = activeInterestPointId != null
  const text = showText ? texts[activeInterestPointId - 1] : ""

  return (
    <TypeFadeTextPresence
      show={showText}
      text={text}
      textKey={activeInterestPointId}
    />
  )
}

export function TypeFadeTextPresence({ show, text, textKey, className }) {
  const wrapRef = useRef(null)
  const tlRef = useRef(null)

  const [mounted, setMounted] = useState(false)
  const [displayedText, setDisplayedText] = useState("")

  useEffect(() => {
    const el = wrapRef.current

    if (show) {
      setMounted(true)
      return
    }

    if (!el) {
      setMounted(false)
      setDisplayedText("")
      return
    }

    if (tlRef.current) tlRef.current.kill()

    tlRef.current = gsap.timeline({
      onComplete: () => {
        setMounted(false)
        setDisplayedText("")
      },
    }).to(el, {
      autoAlpha: 0,
      y: 8,
      duration: 0.2,
      ease: "power2.in",
    })
  }, [show])

  // update texte uniquement quand l'id change
  useEffect(() => {
    if (!show) return
    setDisplayedText(text)
  }, [show, textKey])


  useLayoutEffect(() => {
    if (!mounted) return
    if (!show) return
    const el = wrapRef.current
    if (!el) return

    const chars = el.querySelectorAll("[data-char]")
    if (!chars.length) return

    if (tlRef.current) tlRef.current.kill()

    gsap.set(el, { autoAlpha: 1, y: 0 })
    gsap.set(chars, { autoAlpha: 0, y: 8 })

    tlRef.current = gsap.timeline()
    tlRef.current.to(chars, {
      autoAlpha: 1,
      y: 0,
      duration: 0.35,
      ease: "power2.out",
      stagger: 0.015,
    })
  }, [displayedText, mounted, show])

  if (!mounted) return null

  return (
    <p
      ref={wrapRef}
      className={className}
      style={{ display: "inline-block", whiteSpace: "pre-line" }}
    >
      {displayedText.split("\n").map((line, lineIndex) => (
        <span key={lineIndex} style={{ display: "block" }}>
          {line.split(" ").map((word, wordIndex, arr) => (
            <span
              key={wordIndex}
              style={{
                display: "inline-block",
                marginRight: wordIndex < arr.length - 1 ? "0.25em" : 0, // <-- espace
              }}
            >
              <span
                data-word
                style={{
                  display: "inline-block",
                  whiteSpace: "nowrap",
                }}
              >
                {word.split("").map((ch, i) => (
                  <span key={i} data-char style={{ display: "inline-block" }}>
                    {ch}
                  </span>
                ))}
              </span>
            </span>
          ))}
        </span>
      ))}
    </p>
  )
}
